import './StyleGuide.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faX } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'

import React from 'react'

function ModalGuide() {
    const [modal, setModal] = useState(false)
    const showModal = (e) => {
        if(modal){
            setModal(false)
        }else{
            setModal(true)
        }
        
    }

    if(modal){
        return (
            <div id="elements">
                <h2 className="style_header">Modals/Popups</h2>
                    <div className='modals'>
                        <div className="home_participant_list">
                            <div className="participant_list_top">
                                <FontAwesomeIcon
                                    icon={faXmark}
                                    className="participant_list_top_X"
                                    onClick={()=>setModal(false)}
                                />
                            </div>
                            <div className="participant_list_title">Participants</div>
                                <div className="participant_list_listFrame">
                                    <ul className="participant_list_listFrame_list">
                                        <br/>
                                        Close the modal by clicking on the "x" in the top right of the modal
                                    </ul>
                                </div>
                            </div>
                            <p className='medium'>Our application uses modals to display certain types of information to users.  </p>
                            <p className='medium'> This is used on the activity cards. Icons can be clicked on to bring up a modal displaying event participants and another icon can be selected to show comments on the event.</p>
    
                    {/* <div className='modal_ie'>
                        <div className = "modal_box">
                            <div className='modal_close'><FontAwesomeIcon icon={faX} width="90%" onClick={showModal}/> </div>
                            <div className = "modal_header">
                                <div style={{color:"#053c5e" }}>Sign In</div>
                            </div>
                            <div className = "modal_input">
                                <div className="modal_form">
                                    <label for="modal_email"></label>
                                    <input type="text"  name="modal-email" className="modal_text" placeholder="Email"></input>
                                </div>
                                <div className="modal_form">
                                    <label for="modal_pass"></label>
                                    <input type="password"  name="modal_pass" className="modal_password" placeholder="Password"></input>
                                </div>
                            </div>
                            <div className = "modal_footer">    
                                <button type="submit" className = "modal_button">Sign In</button>
                                <button type="submit" className = "modal_button">Forgot password?</button>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        )
    }else{
        return (
            <div id="elements">
                <h2 className="style_header">Modals/Popups</h2>
                <div className='modals'>
                    <p className='medium'>Our application uses modals to display certain types of information to users.  </p>
                    <p className='medium'> This is used on the activity cards. Icons can be clicked on to bring up a modal displaying event participants and another icon can be selected to show comments on the event.</p>
                    <p className='medium'>View how it works below:</p>
                    <div className='button2'>
                        <button type="button" className="sign_button" onClick={showModal}>Cick to popup modal!</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalGuide